module.exports = __webpack_public_path__ + "img/sourcing@2x.04f93b2.jpg";